const getSuccessSettledResults = <T>(target: PromiseSettledResult<T>[]): T[] =>
  target.reduce<T[]>(
    (list, result) =>
      result.status !== 'fulfilled' ? list : [...list, result.value],
    []
  );

export { getSuccessSettledResults };
